<template>


<section class="kc-elm kc-css-222028 kc_row">
   <div class="befbgr" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim="none"></div>
   <div class="befbgr" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim="none"></div>
   <div class="aftbgr" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim="none"></div>
   <div class="aftbgr" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim="none"></div>
   <div class="befbgr5" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim="none"></div>
   <div class="befbgr6" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim="none"></div>
   <div class="aftbgr7" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim="none"></div>
   <div class="aftbgr8" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim="none"></div>
   <div class="kc-row-container  kc-container">
      <div class="kc-wrap-columns">
         <div class="kc-elm kc-css-986484 kc_col-sm-5 kc_column kc_col-sm-5">
            <div class="kc-col-container">
               <div class="ssc_mltttl  kc-elm kc-css-276148 ">
                  <h2 class="wr deb derb dea dera none nonea">
                     <slot name="title">
                        <span class="t1">Our </span><span class="t2"> clients</span>
                     </slot>
                  </h2>
               </div>
               <div class="ssc_mltttl  kc-elm kc-css-663603 ">
                  <h3 class="wr deb derb dea dera none nonea">
                     <slot name="subtitle">
                     <span class="t1">We worked with awesome peoples</span>
                     </slot>
                  </h3>
               </div>
               <div class="ssc_btn kc-elm kc-css-1251  ">
                  <slot name="action">
                     <a class="ssc_button none" href="/" target="_self"><span>Learn more</span></a>
                  </slot>
               </div>
               <div class="bgrlabel  kc-elm kc-css-629210" style="bottom:-10px;right:60px;">
                  <div class="inside_wrap">
                     <div class="imgl"><img class=" ls-is-cached lazyloaded" data-src="../../assets/images/Plant_.png" alt="" src="../../assets/images/Plant_.png"></div>
                  </div>
               </div>
            </div>
         </div>
         <div class="kc-elm kc-css-954718 kc_col-sm-7 kc_column kc_col-sm-7">
            <div class="kc-col-container">
               <div class="kc-elm kc-css-371231 kc_row kc_row_inner sst-flex-row-inner">

                  <div v-for="client in clients" :key="client" class="kc-elm kc-css-406460 kc_col-sm-4 kc_column_inner kc_col-sm-4">
                     <div class="kc_wrapper kc-col-inner-container">
                        <div class=" type1 mo  none kc-elm kc-css-955950 ssc_img_ef">
                           <div class="iw wow animated slideInDown" data-wow-duration="2s" data-wow-delay="0s" style="background-color: white;"><img alt="" class="none ls-is-cached lazyloaded" :src="require('../../assets/images/'+ client)"></div>
                        </div>
                     </div>
                  </div>

               </div>
            </div>
         </div>
      </div>
   </div>
</section>


</template>

<script>
export default {
  name: "Clients",
  props: ["title", "subtitle", "header", "clients"],
  data() {
    return {
      msg: "Clients"
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media all{
*,.kc-col-container,.kc-container,.kc-elm{box-sizing:border-box;}
div{display:block;}
.kc-elm{float:left;width:100%;}
.kc_col-sm-4{width:33.3333%;}
.kc_col-sm-5{width:41.6667%;}
.kc_col-sm-7{width:58.3333%;}
.kc-container{width:100%;max-width:1170px;margin:0 auto;padding-left:15px;padding-right:15px;}
.kc_row:not(.kc_row_inner){clear:both;float:left;width:100%;}
.kc-row-container.kc-container .kc-wrap-columns,.kc_row_inner{margin-left:-15px;margin-right:-15px;clear:both;}
/* .kc_row.kc_row_inner{width:100%;} */
.kc_row.kc_row_inner{margin:0 auto;width:100%;}
.kc_column,.kc_column_inner{min-height:1px;position:relative;padding-right:15px;padding-left:15px;float:left;}
.kc_column>.kc-col-container,.kc_column_inner>.kc-col-inner-container{height:100%;}
.kingcomposer div.kc_column,.kingcomposer div.kc_column_inner{clear:none;}
.kc-col-container{clear:both;display:block;width:100%;}
@media screen and (min-width:999px){
.kc-row-container .kc-wrap-columns,.kc_row_inner{display:-webkit-flex;display:-ms-flexbox;display:flex;width:100%;flex-wrap:wrap;}
.kc-row-container.kc-container .kc-wrap-columns,.kc_row_inner{width:100%;}
}
@media screen and (max-width:767px){
body.kc-css-system .kc_column,body.kc-css-system .kc_column_inner{width:100%;}
div.kc_row{display:block;}
}
.entry-content a{box-shadow:none;}
*{box-sizing:border-box;}
*:before,*:after{box-sizing:border-box;}
div:focus{outline:none;}
section{display:block;}
img{border:0;max-width:100%;}
h2{font-family:"Montserrat";color:#222;font-weight:500;font-size:40px;line-height:52px;text-transform:full-size-kana;text-align:left;margin:20px 0 15px 0;}
h3{font-family:"Catamaran";color:#222;font-weight:500;font-size:25px;line-height:32px;text-align:left;margin:20px 0;}
*,*:before,*:after{box-sizing:inherit;}
.kc_row.kc_row_inner:focus{outline:none;}
img{height:auto;max-width:100%;}
.kc-row-container:after{content:"";display:block;clear:both;}
.kc-col-container>div{position:relative;}
.kc-col-container>div.bgrlabel{z-index:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;}
@media screen and (max-width:601px){
h2{font-family:"Montserrat";color:#222;font-weight:500;font-size:30px;line-height:34px;text-transform:none;text-align:center;}
h2{font-family:"Montserrat";color:#222;font-weight:500;font-size:30px;line-height:34px;text-transform:none;text-align:center;margin:20px 0;}
}
body .bgrlabel{float:none;position:absolute;display:inline-block;width:auto;}
section{position:relative;}
.befbgr,.befbgr5,.befbgr6{position:absolute;top:0;left:0;width:100%;line-height:0;transition:all 300ms;}
.aftbgr,.aftbgr7,.aftbgr8{position:absolute;bottom:0;left:0;width:100%;line-height:0;transition:all 300ms;}
a.ssc_button{position:relative;display:inline-block;transition:all 300ms ease-in;overflow:hidden;}
a.ssc_button span{position:relative;z-index:5;display:inline-block;}
.ssc_btn:after{content:"";display:block;clear:both;}
@media screen and (max-width:1024px){
.befbgr,.befbgr5,.befbgr6,.aftbgr,.aftbgr7,.aftbgr8{overflow:hidden;}
}
body .ssc_img_ef{position:relative;width:auto;transition:all 300ms ease-in;display:table;}
.ssc_img_ef:hover{z-index:9;}
.ssc_img_ef img{display:inline;transition:all 400ms;margin-bottom:-8px;}
.ssc_img_ef>div{overflow:hidden;display:table-cell;width:100%;height:100%;}
.ssc_img_ef.type1{display:table;}
.ssc_img_ef.type1>div{display:block;}
.ssc_mltttl>h2,.ssc_mltttl>h3{display:inline-block;width:auto;position:relative;}
.deb:before,.dea:after{position:absolute;content:'';display:block;top:0;transition:all 400ms;}
.deb.none:before,.dea.nonea:after{content:none;}
.derb:before,.dera:after{right:0;}
.kc-col-container:after{content:"";display:block;clear:both;}
.sst-flex-row-inner{position:relative;z-index:1;min-height:30px;}
}
/*! CSS Used from: Embedded */
@media (max-width: 479px){
h2{font-size:30px;line-height:34px!important;}
}
/*! CSS Used from: Embedded */
.kc-container{max-width:1170px;}
/*! CSS Used from: Embedded */
@media only screen and (min-width:1000px) and (max-width:5000px){
body.kc-css-system .kc-css-986484{width:43.12%;}
body.kc-css-system .kc-css-954718{width:56.86%;}
body.kc-css-system .kc-css-469135{width:33.33%;}
body.kc-css-system .kc-css-78900{width:33.33%;}
body.kc-css-system .kc-css-285406{width:33.33%;}
body.kc-css-system .kc-css-406460{width:33.33%;}
body.kc-css-system .kc-css-958964{width:33.33%;}
body.kc-css-system .kc-css-68710{width:33.33%;}
}
body.kc-css-system .kc-css-222028{text-align:left;padding-top:0px;padding-bottom:0px;}
body.kc-css-system .kc-css-986484{text-align:left;padding-top:30px;}
body.kc-css-system .kc-css-276148.ssc_mltttl .wr{text-align:left;}
body.kc-css-system .kc-css-276148{text-align:left;display:inline-block;}
body.kc-css-system .kc-css-276148 .deb:before{border-radius:50px 50px 50px 50px;width:40px;height:40px;}
body.kc-css-system .kc-css-276148 .deb:after{border-radius:20px 20px 20px 20px;width:8px;height:8px;margin-top:17px;margin-right:-4px;}
body.kc-css-system .kc-css-276148 .t1{text-align:left;}
body.kc-css-system .kc-css-276148 .t2{color:#ED7D31;text-align:left;}
body.kc-css-system .kc-css-663603.ssc_mltttl .wr{text-align:left;}
body.kc-css-system .kc-css-663603{text-align:left;display:inline-block;}
body.kc-css-system .kc-css-663603 .deb:before{border-radius:50px 50px 50px 50px;width:40px;height:40px;}
body.kc-css-system .kc-css-663603 .deb:after{border-radius:20px 20px 20px 20px;width:8px;height:8px;margin-top:17px;margin-right:-4px;}
body.kc-css-system .kc-css-663603 .t1{text-align:left;}
body.kc-css-system .kc-css-1251.ssc_btn{text-align:left;padding-top:30px;}
body.kc-css-system .kc-css-1251 .ssc_button{color:#222222;font-family:Catamaran;font-size:16px;line-height:45px;font-weight:600;text-decoration:none;border:2px solid #ED7D31;border-radius:30px 30px 30px 30px;padding-right:60px;padding-left:60px;}
body.kc-css-system .kc-css-1251{text-align:center;}
body.kc-css-system .kc-css-1251 .ssc_button:hover{color:#ffffff;background-color:#222222;border:2px solid #222222;}
body.kc-css-system .kc-css-519527{margin-bottom:20px;border:1px solid #dddddd;-webkit-filter:grayscale(0%);filter:grayscale(0%);}
body.kc-css-system .kc-css-140457{margin-bottom:20px;border:1px solid #dddddd;-webkit-filter:grayscale(0%);filter:grayscale(0%);}
body.kc-css-system .kc-css-161839{margin-bottom:20px;border:1px solid #dddddd;-webkit-filter:grayscale(0%);filter:grayscale(0%);}
body.kc-css-system .kc-css-955950{margin-bottom:20px;border:1px solid #dddddd;-webkit-filter:grayscale(0%);filter:grayscale(0%);}
body.kc-css-system .kc-css-73438{margin-bottom:20px;border:1px solid #dddddd;-webkit-filter:grayscale(0%);filter:grayscale(0%);}
body.kc-css-system .kc-css-346348{margin-bottom:20px;border:1px solid #dddddd;-webkit-filter:grayscale(0%);filter:grayscale(0%);}
@media only screen and (max-width:1024px){
body.kc-css-system .kc-css-629210{display:none;opacity:0;}
}
@media only screen and (max-width:999px){
body.kc-css-system .kc-css-222028{padding-top:60px;}
body.kc-css-system .kc-css-986484{padding-bottom:15px;}
body.kc-css-system .kc-css-986484{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-1251.ssc_btn{margin-bottom:50px;text-align: center;}
body.kc-css-system .kc-css-954718{margin-left:0%;width:100%;}
}
@media only screen and (max-width:767px){
body.kc-css-system .kc-css-469135{margin-left:0%;width:50%;}
body.kc-css-system .kc-css-519527{text-align:center;}
body.kc-css-system .kc-css-78900{margin-left:0%;width:50%;}
body.kc-css-system .kc-css-140457{text-align:center;}
body.kc-css-system .kc-css-285406{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-161839{text-align:center;}
body.kc-css-system .kc-css-406460{margin-left:0%;width:50%;}
body.kc-css-system .kc-css-955950{text-align:center;}
body.kc-css-system .kc-css-958964{margin-left:0%;width:50%;}
body.kc-css-system .kc-css-73438{text-align:center;}
body.kc-css-system .kc-css-68710{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-346348{text-align:center;}
}
@media only screen and (max-width:479px){
body.kc-css-system .kc-css-222028{padding-bottom:0px;}
}

</style>



// WEBPACK FOOTER //
// src/components/Blocks/Clients.vue